import React from 'react';
import PropTypes from 'prop-types';
import connectToStores from 'fluxible-addons-react/connectToStores';
import { loadDataAction } from 'apps/favorite-designer/actions';
import FavoriteDesignerActuator from './FavoriteDesignerActuator';
import FavoriteDesignerIndicatorIcon from './FavoriteDesignerIndicatorIcon';
import FavoriteDesignerStore from './FavoriteDesignerStore';

class FavoriteDesigner extends React.Component {
    componentDidMount() {
        this.context.executeAction(loadDataAction, { url: this.props.xhrUrl });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.xhrUrl !== this.props.xhrUrl) {
            this.context.executeAction(loadDataAction, { url: nextProps.xhrUrl });
        }
    }

    indicator() {
        const props = { designer: this.props.designer, isFavorite: this.props.isFavorite };
        return <FavoriteDesignerIndicatorIcon {...props} />;
    }

    render() {
        return (
            <FavoriteDesignerActuator
                isReady={this.props.isReady}
                isFavorite={this.props.isFavorite}
                xhrUrl={this.props.xhrUrl}
            >
                {this.indicator()}
            </FavoriteDesignerActuator>
        );
    }
}

FavoriteDesigner.propTypes = {
    designer: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    xhrUrl: PropTypes.string.isRequired,
    isFavorite: PropTypes.bool,
    isReady: PropTypes.bool,
};

FavoriteDesigner.defaultProps = {
    isFavorite: false,
    isReady: false,
};

FavoriteDesigner.contextTypes = {
    executeAction: PropTypes.func,
};

export default connectToStores(
    FavoriteDesigner,
    [FavoriteDesignerStore],
    (ctx) => {
        const s = ctx.getStore(FavoriteDesignerStore);
        return {
            isFavorite: s.isFavorite,
            isReady: s.isLoaded,
        };
    },
);



// WEBPACK FOOTER //
// ./src/js/apps/favorite-designer/FavoriteDesigner.jsx